import { Flex, Text } from '@chakra-ui/react'
import ApexCharts from 'apexcharts'
import { useEffect, useRef } from 'react'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { ObterCorPercentual } from '../../../../../Utils/Helper'

interface iGaugeIndicadorProps {
  id: string
  nome: string
  pctPrincipal: number
  legendaPrincipal: string
  acumuladoLabel: string
  previstoLabel: string
  metaLabel: string
}

export const GaugeIndicador: React.FC<iGaugeIndicadorProps> = ({ id, nome, pctPrincipal, legendaPrincipal, acumuladoLabel, previstoLabel, metaLabel }) => {
  const chartRef = useRef<ApexCharts | null>(null)
  const indisponivel = acumuladoLabel === 'N/A'

  useEffect(() => {
    const element = document.querySelector(`#gauge-${id}`)
    if (!element) return

    if (chartRef.current) {
      chartRef.current.destroy()
      chartRef.current = null
    }

    const options = {
      series: [indisponivel ? 100 : Math.min(100, pctPrincipal)],
      chart: {
        type: 'radialBar',
        offsetY: -20,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: '#e7e7e7',
            strokeWidth: '97%',
            margin: 5,
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              color: '#999',
              opacity: 1,
              blur: 2
            }
          },
          dataLabels: {
            name: {
              show: false
            },
            value: {
              show: true,
              fontSize: '24px',
              fontWeight: 600,
              offsetY: -2,
              formatter: function () {
                return indisponivel ? 'N/A' : pctPrincipal.toFixed(1) + '%'
              }
            }
          }
        }
      },
      fill: {
        colors: [ObterCorPercentual(pctPrincipal, indisponivel)]
      }
    }

    const chart = new ApexCharts(element, options)
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    chart.render()
    chartRef.current = chart

    return () => {
      chart.destroy()
      chartRef.current = null
    }
  }, [id, pctPrincipal, indisponivel])

  return (
    <Flex
      flexDir={'column'}
      alignItems={'center'}
      bg={'var(--c1)'}
      border={'1px solid var(--c5)'}
      borderRadius={'.5rem'}
      padding={'1rem'}
      boxShadow={'var(--SombraBackground)'}
    >
      <ElementoTooltipCmp label={nome}>
        <Text
          fontWeight={'700'}
          fontSize={'.95rem'}
          textAlign={'center'}
          noOfLines={1}
          maxW={'18rem'}
          color={'var(--Gray1)'}
        >
          {nome}
        </Text>
      </ElementoTooltipCmp>

      <Flex id={`gauge-${id}`} justifyContent={'center'} w={'100%'} mt={'.5rem'} />

      <Text fontSize={'.75rem'} color={'var(--Gray3)'} mt={'-1.25rem'} textAlign={'center'}>{legendaPrincipal}</Text>

      <Flex flexDir={'column'} gap={'.15rem'} mt={'.75rem'} w={'100%'} fontSize={'.8rem'}>
        <Flex justifyContent={'space-between'}>
          <Text color={'var(--Gray3)'}>Acumulado</Text>
          <Text fontWeight={'600'}>{acumuladoLabel}</Text>
        </Flex>
        <Flex justifyContent={'space-between'}>
          <Text color={'var(--Gray3)'}>Previsto</Text>
          <Text fontWeight={'600'}>{previstoLabel}</Text>
        </Flex>
        <Flex justifyContent={'space-between'}>
          <Text color={'var(--Gray3)'}>Meta</Text>
          <Text fontWeight={'600'}>{metaLabel}</Text>
        </Flex>
      </Flex>
    </Flex>
  )
}
